/**
 * Process data
 */

export function HerotSaveToken(imgData: any, sourceId: any, type: any, tokenTitle: string, color: any, userId: string) {

    let processdata = {
        title: tokenTitle,
        imgtype: type,
        sourceid: sourceId,
        userkey: userId,
        color: color,
        rawdata: imgData,
        imgdata: imgData.replace(/^data:image\/.*;base64,/, ""),
    }

    //console.log(imgData.replace(/^data:image\/.*;base64,/, ""));
    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/save-heroic-token', {
            method: "POST",
            body: JSON.stringify(processdata),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
    //return {tokenid:'5',sourceid:sourceId};

}

export function HerotSaveSourceImage(imgData: any, type: any, title: string, userId: string) {

    let processdata = {
        title: title,
        imgtype: type,
        userkey: userId,
        rawdata: imgData,
        imagedata: imgData.replace(/^data:image\/.*;base64,/, ""),
    }
    //console.log(imgData.replace(/^data:image\/.*;base64,/, ""));


    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/save-source-image', {
            method: "POST",
            body: JSON.stringify(processdata), //formData, 

            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
    //return {sourceid:'123'};

}

export function HerotSaveCustomBorder(imgData: any, type: any, offset: number, imgpro: string, shape: string, userId: string) {

    let processdata = {
        imgoffset: offset,
        imgpro: imgpro,
        imgshape: shape,
        imgtype: type,
        userkey: userId,
        imagedata: imgData.replace(/^data:image\/.*;base64,/, ""),
    }

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/save-ht-border-v2', {
            method: "POST",
            body: JSON.stringify(processdata), //formData, 

            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
    //return {sourceid:'123'};

}

export function UpdateCustomBorderOffset(userId: string, borderId: number, offset: number, horizontalMovePercentage: number, verticalMovePercentage: number) {

    let processdata = {
        imgoffset: offset,
        borderid: borderId,
        hrmoveper: horizontalMovePercentage,
        vrmoveper: verticalMovePercentage, 
        userkey: userId,        
    }

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/save-border-offset', {
            method: "POST",
            body: JSON.stringify(processdata), //formData, 

            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
    //return {sourceid:'123'};

}

export function HerotGetImageData(imgId: any, imgCat: any, userId: string) {

    let processdata = {
        imgId: imgId,
        imgCat: imgCat,
        userkey: userId,        
    }

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/get-image-by-id?userkey='+userId+'&imgcat='+imgCat+'&imgid='+imgId, {
            method: "GET",
    
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
}

export function HerotGetAiData(aiData: any, inputValue: string, userId: string) {

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/get-ai-data?userkey='+userId+'&inputvalue='+inputValue+'&aidata='+aiData, {
            method: "GET",
    
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
}

export function GetInitialData(userId: string) {

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/get-ini-data?userkey='+userId, {
            method: "GET",
    
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json()
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
}

export function GetInitialBorders(userId: string) {

    return new Promise((resolve, reject) => (
        fetch('https://heroictoken.com/wp-json/heroic/v1/get-ht-borders?userkey='+userId, {
            method: "GET",
    
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
            .then(response =>
                response.json() 
            )
            .then(json => resolve(json))
            .catch(err => reject(err))

    ))
} 